import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import $ from "jquery";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GalleryPageIamge from "../assets/img/GalleryPageIamge.jpg";
import puff_img3 from "../assets/img/puff_img3.png";
import bread_img1 from "../assets/img/bread_img1.webp";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import toastFour from "../assets/img/homePageMenuItemsImages/toastFour.jpg";
import puffOne from "../assets/img/homePageMenuItemsImages/puffOne.png";
import ToastOne from "../assets/img/homePageMenuItemsImages/ToastOne.png";
import toastTwo from "../assets/img/homePageMenuItemsImages/toastTwo.png";
import creamRollOne from "../assets/img/homePageMenuItemsImages/creamRollOne.png";
import creamRollTwo from "../assets/img/homePageMenuItemsImages/creamRollTwo.png";
import creamRollThree from "../assets/img/homePageMenuItemsImages/creamRollThree.png";
import khariOne from "../assets/img/homePageMenuItemsImages/khariOne.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import cakeImageFiveZeppoli from "../assets/img/menuItemImages/cakeImageFiveZeppoli.webp";
import cakeImageFourZeppoli from "../assets/img/menuItemImages/cakeImageFourZeppoli.webp";
import cakeImageOneZeppoli from "../assets/img/menuItemImages/cakeImageOneZeppoli.webp";
import cakeImageSevenZeppoli from "../assets/img/menuItemImages/cakeImageSevenZeppoli.webp";
import cakeImageSixZeppoli from "../assets/img/menuItemImages/cakeImageSixZeppoli.webp";
import cakeImageThreeZeppoli from "../assets/img/menuItemImages/cakeImageThreeZeppoli.webp";
import cakeImageTwoZeppoli from "../assets/img/menuItemImages/cakeImageTwoZeppoli.webp";
import dessertImageOneZeppoli from "../assets/img/menuItemImages/dessertImageOneZeppoli.webp";
import dessertImageThreeZeppoli from "../assets/img/menuItemImages/dessertImageThreeZeppoli.webp";
import donutDelightsZeppoli from "../assets/img/menuItemImages/donutDelightsZeppoli.png";
import dessertImageTwoZeppoli from "../assets/img/menuItemImages/dessertImageTwoZeppoli.webp";
import farsanFiveZeppoli from "../assets/img/menuItemImages/farsanFiveZeppoli.webp";
import farsanFourZeppoli from "../assets/img/menuItemImages/farsanFourZeppoli.webp";
import farsanOneZeppoli from "../assets/img/menuItemImages/farsanOneZeppoli.webp";
import farsanSixZeppoli from "../assets/img/menuItemImages/farsanSixZeppoli.webp";
import farsanThreeZeppoli from "../assets/img/menuItemImages/farsanThreeZeppoli.webp";
import farsanTwoZeppoli from "../assets/img/menuItemImages/farsanTwoZeppoli.webp";
import PastryImageFive from "../assets/img/menuItemImages/PastryImageFive.webp";
import PastryImageFour from "../assets/img/menuItemImages/PastryImageFour.webp";
import PastryImageOne from "../assets/img/menuItemImages/PastryImageOne.webp";
import PastryImageSix from "../assets/img/menuItemImages/PastryImageSix.webp";
import PastryImageThree from "../assets/img/menuItemImages/PastryImageThree.webp";
import PastryImageTwo from "../assets/img/menuItemImages/PastryImageTwo.webp";
import breadOneZeppoli from "../assets/img/menuItemImages/breadOneZeppoli.webp";
import breadTwoZeppoli from "../assets/img/menuItemImages/breadTwoZeppoli.webp";
import breadThreeZeppoli from "../assets/img/menuItemImages/breadThreeZeppoli.webp";
import breadFourZeppoli from "../assets/img/menuItemImages/breadFourZeppoli.webp";
import breadFiveZeppoli from "../assets/img/menuItemImages/breadFiveZeppoli.webp";
import breadSixZeppoli from "../assets/img/menuItemImages/breadSixZeppoli.webp";
import breadSevenZeppoli from "../assets/img/menuItemImages/breadSevenZeppoli.webp";
import khariThree from "../assets/img/menuItemImages/khariThree.webp";
import khariFour from "../assets/img/menuItemImages/khariFour.webp";
import khariSix from "../assets/img/menuItemImages/khariSix.webp";
import khariSeven from "../assets/img/menuItemImages/khariSeven.webp";
import khariNine from "../assets/img/menuItemImages/khariNine.webp";
import { motion } from "framer-motion";
import ChilliGazak from "../assets/img/menuItemImages/ChilliGazak.webp";
import MasalaSesoning from "../assets/img/menuItemImages/MasalaSesoning.webp";
import MixFruitCookies from "../assets/img/menuItemImages/MixFruitCookies.webp";
import cookieAlmondButter from "../assets/img/menuItemImages/cookies/Almond Butter Cookie.png";
import cookieAlmondCrunch from "../assets/img/menuItemImages/cookies/Almond Crunch.png";
import cookieAlmondStick from "../assets/img/menuItemImages/cookies/Almond Stick.png";
import cookieBrownBite from "../assets/img/menuItemImages/cookies/Brown Bite Cookie.png";
import cookieCakeRusk from "../assets/img/menuItemImages/cookies/Cake Rusk.png";
import cookieCashewBite from "../assets/img/menuItemImages/cookies/Cashew Bite Cookie.png";
import cookieCheesePop from "../assets/img/menuItemImages/cookies/Cheese Pop.png";
import cookieChocoBrownie from "../assets/img/menuItemImages/cookies/Choco Brownie Cookie.png";
import cookieChocoCrust from "../assets/img/menuItemImages/cookies/Choco Crust Cookie.png";
import cookieCookieNuts from "../assets/img/menuItemImages/cookies/Cookie Nuts Cookie.png";
import cookieFruitNNut from "../assets/img/menuItemImages/cookies/Fruit N Nut Cookie.png";
import cookieGoodDayKaju from "../assets/img/menuItemImages/cookies/Good Day Kaju Cookie.png";
import cookieMilletChoco from "../assets/img/menuItemImages/cookies/Millet Choco Cookie.png";
import cookiePistaCrunch from "../assets/img/menuItemImages/cookies/Pista Crunch.png";
import cookiePistaStick from "../assets/img/menuItemImages/cookies/Pista Stick.png";
import cookiePureGheeNankhatai from "../assets/img/menuItemImages/cookies/Pure Ghee Nankhatai.png";
import cookieWheatAlmond from "../assets/img/menuItemImages/cookies/Wheat Almond Cookie.png";
import FruitToast from "../assets/img/menuItemImages/FruitToast.webp";
import JeeraToast from "../assets/img/menuItemImages/JeeraToast.webp";
import StickToast from "../assets/img/menuItemImages/StickToast.webp";

function PopularMenuItems() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Home";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  /*----------- 08. Custom Animaiton For Slider ----------*/
  useEffect(() => {
    document.querySelectorAll("[data-ani-duration]").forEach((element) => {
      const durationTime = element.getAttribute("data-ani-duration");
      element.style.animationDuration = durationTime;
    });

    document.querySelectorAll("[data-ani-delay]").forEach((element) => {
      const delayTime = element.getAttribute("data-ani-delay");
      element.style.animationDelay = delayTime;
    });

    document.querySelectorAll("[data-ani]").forEach((element) => {
      const animationName = element.getAttribute("data-ani");
      element.classList.add(animationName);
      document
        .querySelector(".slick-current [data-ani]")
        .classList.add("th-animated");
    });

    const handleAfterChange = (event, slick, currentSlide, nextSlide) => {
      slick.$slides.forEach((slide) => {
        slide.querySelectorAll("[data-ani]").forEach((element) => {
          element.classList.remove("th-animated");
        });
      });

      slick.$slides[currentSlide]
        .querySelectorAll("[data-ani]")
        .forEach((element) => {
          element.classList.add("th-animated");
        });
    };

    const carouselElement = document.querySelector(".th-carousel");

    if (carouselElement) {
      carouselElement.addEventListener("afterChange", handleAfterChange);
    }

    return () => {
      if (carouselElement) {
        carouselElement.removeEventListener("afterChange", handleAfterChange);
      }
    };
  }, []);

  useEffect(() => {
    // Handle filter button click
    $(".tab-menu1 button").on("click", function () {
      const filterValue = $(this).attr("data-filter");

      // Remove the 'active' class from all buttons and add it to the clicked button
      $(".tab-menu1 button").removeClass("active");
      $(this).addClass("active");

      // Hide all items and show only the ones with the selected class
      $(".filter-active .filter-item").hide();
      $(`.filter-active .filter-item${filterValue}`).show();
    });
  }, []);

  // for menu items Our Popular Delicious Foods
  const menuItems = [
    {
      categoryClassName: "cat1",
      image: cakeImageOneZeppoli,
      title: "Rocher Ferrero",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat1",
      image: cakeImageTwoZeppoli,
      title: "Choco Nuts",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat2",
      image: PastryImageOne,
      title: "Blue Berry Pastry",
      categoryName: "Pastry",
    },
    {
      categoryClassName: "cat2",
      image: PastryImageTwo,
      title: "Chocolate Silk Pastry",
      categoryName: "Pastry",
    },
    {
      categoryClassName: "cat6",
      image: puffOne,
      title: "Irani Special Puff",
      categoryName: "Puff",
    },
    {
      categoryClassName: "cat6",
      image: puff_img3,
      title: "Aloo Puff",
      categoryName: "Puff",
    },
    {
      categoryClassName: "cat4",
      image: StickToast,
      title: "Stick Toast",
      categoryName: "Toast",
    },
    {
      categoryClassName: "cat4",
      image: JeeraToast,
      title: "Jeera Toast",
      categoryName: "Toast",
    },
    {
      categoryClassName: "cat8",
      image: creamRollOne,
      title: "Vanilla Cream Roll",
      categoryName: "Cream Roll",
    },
    {
      categoryClassName: "cat8",
      image: creamRollTwo,
      title: "Chocolate Cream Roll",
      categoryName: "Cream Roll",
    },
    {
      categoryClassName: "cat7",
      image: farsanOneZeppoli,
      title: "Mix Chavanu",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat7",
      image: farsanTwoZeppoli,
      title: "Butter Bhakharvadi",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat3",
      image: khariThree,
      title: "Butter Khari",
      categoryName: "Khari",
    },
    {
      categoryClassName: "cat3",
      image: khariSeven,
      title: "Jeera Khari",
      categoryName: "Khari",
    },
    {
      categoryClassName: "Dessert",
      image: dessertImageOneZeppoli,
      title: "Biscoff Cheesecake",
      categoryName: "Dessert",
    },
    {
      categoryClassName: "Dessert",
      image: dessertImageTwoZeppoli,
      title: "Blue Berry Cheesecake",
      categoryName: "Dessert",
    },
    {
      categoryClassName: "cat9",
      image: breadOneZeppoli,
      title: "White Sliced Bread",
      categoryName: "Bread",
    },
    {
      categoryClassName: "cat9",
      image: breadTwoZeppoli,
      title: "White Sliced Bread",
      categoryName: "Bread",
    },

    {
      categoryClassName: "cat1",
      image: cakeImageThreeZeppoli,
      title: "Royal Cassata",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat1",
      image: cakeImageFourZeppoli,
      title: "Choco Oreo",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat1",
      image: cakeImageFiveZeppoli,
      title: "Red Velvet",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat1",
      image: cakeImageSixZeppoli,
      title: "Rasmalay",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat1",
      image: cakeImageSevenZeppoli,
      title: "Dark Chocolate",
      categoryName: "Cake",
    },

    {
      categoryClassName: "cat2",
      image: PastryImageThree,
      title: "Fruit Pastry",
      categoryName: "Pastry",
    },
    {
      categoryClassName: "cat2",
      image: PastryImageFour,
      title: "Choco Chips Pastry",
      categoryName: "Pastry",
    },
    {
      categoryClassName: "cat2",
      image: PastryImageFive,
      title: "Vanilla Pastry",
      categoryName: "Pastry",
    },
    {
      categoryClassName: "cat2",
      image: PastryImageSix,
      title: "Choco Nuts Pastry",
      categoryName: "Pastry",
    },

    {
      categoryClassName: "cat4",
      image: FruitToast,
      title: "Fruit Toast",
      categoryName: "Toast",
    },
    {
      categoryClassName: "cat4",
      image: ToastOne,
      title: "Cake Rusk",
      categoryName: "Toast",
    },
    {
      categoryClassName: "cat4",
      image: toastFour,
      title: "Butter Toast",
      categoryName: "Toast",
    },

    {
      categoryClassName: "cat5",
      image: cookieAlmondButter,
      title: "Almond Butter Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieAlmondCrunch,
      title: "Almond Crunch",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieAlmondStick,
      title: "Almond Stick",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieBrownBite,
      title: "Brown Bite Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieCakeRusk,
      title: "Cake Rusk",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieCashewBite,
      title: "Cashew Bite Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieCheesePop,
      title: "Cheese Pop",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieChocoBrownie,
      title: "Choco Brownie Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieChocoCrust,
      title: "Choco Crust Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieCookieNuts,
      title: "Cookie Nuts Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieFruitNNut,
      title: "Fruit N Nut Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieGoodDayKaju,
      title: "Good Day Kaju Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieMilletChoco,
      title: "Millet Choco Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookiePistaCrunch,
      title: "Pista Crunch",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookiePistaStick,
      title: "Pista Stick",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookiePureGheeNankhatai,
      title: "Pure Ghee Nankhatai",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: cookieWheatAlmond,
      title: "Wheat Almond Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat5",
      image: MixFruitCookies,
      title: "Mix Fruit Cookie",
      categoryName: "Cookie",
      imageModifier: "mixFruit",
    },

    {
      categoryClassName: "cat8",
      image: creamRollThree,
      title: "Strawberry Cream Roll",
      categoryName: "Cream Roll",
    },

    {
      categoryClassName: "cat7",
      image: farsanThreeZeppoli,
      title: "Masala seasoning",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat7",
      image: farsanFourZeppoli,
      title: "Masala Sticks",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat7",
      image: farsanFiveZeppoli,
      title: "Masala Wafers",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat7",
      image: farsanSixZeppoli,
      title: "Masala Banana Wafers",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat7",
      image: ChilliGazak,
      title: "Chilli Gazak",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat7",
      image: MasalaSesoning,
      title: "Masala Sesoning",
      categoryName: "Farsan",
    },

    {
      categoryClassName: "cat3",
      image: khariFour,
      title: "Wheat Khari",
      categoryName: "Khari",
    },
    {
      categoryClassName: "cat3",
      image: khariSix,
      title: "Regular Khari",
      categoryName: "Khari",
    },

    {
      categoryClassName: "cat3",
      image: khariNine,
      title: "Masala Khari",
      categoryName: "Khari",
    },
    {
      categoryClassName: "cat3",
      image: khariOne,
      title: "Garlic Khari",
      categoryName: "Khari",
    },

    {
      categoryClassName: "Dessert",
      image: dessertImageThreeZeppoli,
      title: "Royal Choco Walnut",
      categoryName: "Dessert",
    },
    {
      categoryClassName: "Dessert",
      image: donutDelightsZeppoli,
      title: "Donut Delights",
      categoryName: "Dessert",
    },

    {
      categoryClassName: "cat9",
      image: breadThreeZeppoli,
      title: "Burger Bun",
      categoryName: "Bun",
    },
    {
      categoryClassName: "cat9",
      image: breadFourZeppoli,
      title: "Garlic Loaf",
      categoryName: "Pav",
    },
    {
      categoryClassName: "cat9",
      image: breadFiveZeppoli,
      title: "Fresh Pav",
      categoryName: "Pav",
    },
    {
      categoryClassName: "cat9",
      image: breadSixZeppoli,
      title: "White Sliced Bread",
      categoryName: "Bread",
    },
    {
      categoryClassName: "cat9",
      image: breadSevenZeppoli,
      title: "Crustless Sliced Bread",
      categoryName: "Bread",
    },
  ];

  const [cards, setCards] = useState(menuItems);
  const [currentCard, setCurrentCard] = useState("cat1");
  const handleBtns = (e) => {
    let word = e.target.value;
    setCurrentCard(word);
  };
  useEffect(() => {
    if (currentCard === "") {
      setCards(menuItems);
    } else {
      const filtered = menuItems.filter((card) => {
        return (
          card.categoryClassName === currentCard ||
          card.categoryClassName.includes(currentCard)
        );
      });
      setCards(filtered);
    }
  }, [currentCard]);

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    // Set a timeout to change the visibility after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // for animation end

  return (
    <>
      <Navbar />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper " data-bg-src={GalleryPageIamge}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">Popular Menu Items</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">Popular Menu Items</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{ opacity: 2, scale: 1, transition: { duration: 1.5 } }}
      >
        <div
          className="shape-mockup chili jump-reverse"
          data-top="0%"
          data-right="0"
          style={{ right: "0px" }}
        >
          <img src={bread_img1} alt="Zeppoli menu item image" />
        </div>
      </motion.div>

      <section className="space">
        <div className="container">
          <div className="title-area text-center">
            {isVisible && (
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={variants5}
              >
                <span className="sub-title">Popular Menu</span>
                <h2 className="sec-title">Our Popular Delicious Foods</h2>
                <p className="sec-text ms-auto me-auto">
                  Discover the joy of savoring moments with Zeppoli Bakers –
                  where quality meets creativity, and every bite is a
                  celebration of exceptional taste.
                </p>
              </motion.div>
            )}
            <div className="tab-menu1" role="tablist">
              <button
                className={`mx-1 ${currentCard == "cat1" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="cat1"
                name="cakeButton"
                aria-label="cakeButton"
              >
                Cake
              </button>
              <button
                className={`mx-1 ${currentCard == "cat2" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="cat2"
                name="pastryButton"
                aria-label="pastryButton"
              >
                Pastry
              </button>
              <button
                className={`mx-1 ${currentCard == "cat3" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="cat3"
                name="khariButton"
                aria-label="khariButton"
              >
                Khari
              </button>
              <button
                className={`mx-1 ${currentCard == "cat4" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="cat4"
                name="toastButton"
                aria-label="toastButton"
              >
                Toast
              </button>
              <button
                className={`mx-1 ${currentCard == "cat5" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="cat5"
                name="cookieButton"
                aria-label="cookieButton"
              >
                Cookie
              </button>
              <button
                className={`mx-1 ${currentCard == "cat6" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="cat6"
                name="puffButton"
                aria-label="puffButton"
              >
                Puff
              </button>
              <button
                className={`mx-1 ${currentCard == "cat7" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="cat7"
                name="farsanButton"
                aria-label="farsanButton"
              >
                Farsan
              </button>
              <button
                className={`mx-1 ${currentCard == "cat8" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="cat8"
                name="creamRollButton"
                aria-label="creamRollButton"
              >
                Cream Roll
              </button>
              <button
                className={`mx-1 ${currentCard == "Dessert" ? "active" : ""}`}
                type="button"
                onClick={handleBtns}
                value="Dessert"
                name="dessertButton"
                aria-label="dessertButton"
              >
                Dessert
              </button>
            </div>
          </div>

          <div className="row gy-40">
            {cards.map((data, index) => {
              return (
                <div
                  className={`col-xl-3 col-lg-4 col-sm-6 ${data.categoryClassName}`}
                  key={index}
                >
                  {isVisible && (
                    <motion.div
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      variants={variants5}
                    >
                      <div className="th-product product_style1">
                        <div
                          style={{
                            filter:
                              "drop-shadow(0.15rem 0.15rem 0.2rem rgba(0, 0, 0, 0.5))",
                            borderRadius: "10px",
                          }}
                          className={`popular-menu-product-img mx-30${
                            data.imageModifier === "mixFruit"
                              ? " popular-menu-product-img--mix-fruit"
                              : ""
                          }`}
                        >
                          <LazyLoadImage
                            alt="Zeppoli items image"
                            className="popular-menu-product-img__img"
                            wrapperClassName="popular-menu-product-img__wrap"
                            effect="blur"
                            height="100%"
                            width="100%"
                            src={data.image}
                            placeholderSrc={data.image}
                          />
                        </div>
                        <div className="product-content my-4">
                          <p className="product-title">{data.title}</p>
                          <span className="price"></span>
                        </div>
                      </div>
                    </motion.div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default PopularMenuItems;
